// extracted by mini-css-extract-plugin
export var brand = "_redotech-redo-web-lib-icon-brand";
export var compact = "_redotech-redo-web-lib-icon-compact";
export var extraSmall = "_redotech-redo-web-lib-icon-extra-small";
export var icon = "_redotech-redo-web-lib-icon-icon";
export var large = "_redotech-redo-web-lib-icon-large";
export var light = "_redotech-redo-web-lib-icon-light";
export var medium = "_redotech-redo-web-lib-icon-medium";
export var outline = "_redotech-redo-web-lib-icon-outline";
export var primaryDark = "_redotech-redo-web-lib-icon-primary-dark";
export var primaryLight = "_redotech-redo-web-lib-icon-primary-light";
export var primaryModern = "_redotech-redo-web-lib-icon-primary-modern";
export var success = "_redotech-redo-web-lib-icon-success";
export var successSolid = "_redotech-redo-web-lib-icon-success-solid";